import {
  ChatActionTypes,
  SET_CHAT,
  Chat,
  SET_CHAT_DETAILS,
  GET_CHAT_DETAILS,
} from './types';

const initialState: Chat = {
  chat: [],
  isLoading: false,
};

export const chatReducer = (state = initialState, action: ChatActionTypes) => {
  const { type, chat, chatDetails } = action;
  switch (type) {
    case GET_CHAT_DETAILS: {
      return { ...state, chat, isLoading: true };
    }
    case SET_CHAT:
      return { ...state, chat, isLoading: false };
    case SET_CHAT_DETAILS:
      return { ...state, chatDetails: chatDetails };
    default:
      return state;
  }
};
